{
  "decrease": "{fieldLabel}を縮小",
  "increase": "{fieldLabel}を拡大",
  "numberField": "数値フィールド"
}
